var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"width":"100","persistent":""},model:{value:(_vm.dialogLoader),callback:function ($$v) {_vm.dialogLoader=$$v},expression:"dialogLoader"}},[_c('v-img',{attrs:{"src":_vm.AssetImage('img', 'SSMJ Assets/ssmjspinner.gif'),"width":"350"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }